module.exports = __webpack_public_path__ + "img/outdoor-pc.541e67d5.jpg";